module.exports = __webpack_public_path__ + "static/assets/6f058900238a090d63e87858da3e7fa5.png";